import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, Router } from '@angular/router';
import { Breadcrumb } from './shared/breadcrumb';
import { filter } from "rxjs/operators";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {


  public breadcrumbs: Array<Breadcrumb>;

  constructor(
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.breadcrumbs = new Array<Breadcrumb>();
  }

  ngOnInit() {
    this.breadcrumbs = this.getBreadcrumbs(this.route);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => {
      let root: ActivatedRoute = this.route.root;
      this.breadcrumbs = this.getBreadcrumbs(root);
    });
  }

  getCategory() {
    return this.breadcrumbs[1].path;
  }

  generateLink(breadcrumb: Breadcrumb): Array<string | Params> {
    if (breadcrumb.url == "/" || breadcrumb.url == "//") {
      return [breadcrumb.url];
    } else {
      return [breadcrumb.url, breadcrumb.params];
    }
  }


  private getBreadcrumbs(route: ActivatedRoute, url: string = ""): Breadcrumb[] {
    const ROUTE_DATA_BREADCRUMB: string = "breadcrumb";
    let breadcrumbs = new Array<Breadcrumb>();

    let label:string = route.snapshot.data[ROUTE_DATA_BREADCRUMB];
    let reg = new RegExp(/\:(\w+)\.(\w+)/);
    for (let key in route.snapshot.data) {
      if(label.includes(':'+key) && route.snapshot.data[key] != undefined){
        let match = reg.exec(label);
        label = label.replace(match[0],route.snapshot.data[match[1]][match[2]]);
      }      
    }

    if (route.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB) && route.outlet === PRIMARY_OUTLET) {
      let routeURL: string = route.snapshot.url.map(segment => segment.path).join("/");
      url += `/${routeURL}`;

      //add breadcrumb
      let breadcrumb: Breadcrumb = {
        label: label,
        params: route.snapshot.params,
        path: route.snapshot.url.map(segment => segment.path).join(),
        url: url
      };
      breadcrumbs.push(breadcrumb);
    }
    let children: ActivatedRoute[] = route.children;

    for (let child of children) {
      breadcrumbs = breadcrumbs.concat(this.getBreadcrumbs(child, url));
    }
    return breadcrumbs;
  }


}
